import { List } from 'immutable';
import { defaultMemoize } from 'reselect';

const isSalesLoading = defaultMemoize(
    (data) => data.get('loaded') === 'loading',
);
const getSalesTotal = (data) => data.get('total');
const getSalesPage = (data) => data.get('page');
const getSales = defaultMemoize((data) => data.get('sales', List()));

const isFeaturedSalesLoading = defaultMemoize(
    (data) => data.get('loaded') === 'loading',
);
const getFeaturedSales = defaultMemoize((data) => data.get('sales', List()));

export {
    isFeaturedSalesLoading,
    isSalesLoading,
    getFeaturedSales,
    getSalesTotal,
    getSalesPage,
    getSales,
};
